import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { styled } from 'styled-components';
import { GuidaFrameworkProviders, GuidaMenu, useGuidaUIStates } from '@inter-ikea-guida/framework';
import { SkapaTokens } from '@inter-ikea-guida/skapa';
import config from '../../config';
import { useKompis } from '../../contexts';
import useMenu from '../../hooks/useMenu';
import { PaxHeader } from './PaxHeader';
const StyledPaxContainer = styled.div ``;
const StyledPaxContent = styled.div `
  padding-inline: ${SkapaTokens.space150};
`;
export const PaxLayout = ({ children, storeId, stores, isRtl, backButtonText, onBackButtonClick, isKiosk }) => {
    const { isSidebarMode } = useGuidaUIStates();
    const { dexfAppSettings, translations } = useKompis();
    const { dexfApiKey } = config;
    const { isMenuOpen, zipCode, openMenu, closeMenu, onZipCodeChange, onStoreChange } = useMenu();
    return (_jsx(GuidaFrameworkProviders, { dexfAppSettings: dexfAppSettings, children: _jsxs(StyledPaxContainer, { id: 'guida-wrapper', children: [_jsx(PaxHeader, { onBackButtonClick: onBackButtonClick, isRtl: isRtl, kompisTranslations: translations.kompis, backButtonText: backButtonText, onMenuClick: openMenu }), _jsx(GuidaMenu, { kompisTranslations: translations.kompis, settings: dexfAppSettings, theme: SkapaTheme, disableLinks: isKiosk, isOpened: isMenuOpen, onClose: closeMenu, disableExitPrompt: true, zipCodeOptions: {
                        zipCode,
                        onZipCodeChange,
                        dexfApiKey
                    }, storeSelectorOptions: {
                        storeId: storeId || null,
                        stores: stores ?? [],
                        onStoreChange: newStoreId => {
                            onStoreChange(newStoreId, dexfAppSettings);
                        }
                    } }), _jsx(StyledPaxContent, { "$isSidebarMode": isSidebarMode, children: children })] }) }));
};
//# sourceMappingURL=PaxLayout.js.map